// import React from 'react';
// import { useTheme } from '@mui/material';
// import ReactEcharts from 'echarts-for-react';

// const DoughnutChart = ({ height, color = [] }) => {
//   const theme = useTheme();

//   const option = {
//     legend: {
//       show: true,
//       itemGap: 20,
//       icon: 'circle',
//       bottom: 0,
//       textStyle: {
//         color: theme.palette.text.secondary,
//         fontSize: 13,
//         fontFamily: 'roboto'
//       }
//     },
//     tooltip: {
//       show: false,
//       trigger: 'item',
//       formatter: '{a} <br/>{b}: {c} ({d}%)'
//     },
//     xAxis: [
//       {
//         axisLine: {
//           show: false
//         },
//         splitLine: {
//           show: false
//         }
//       }
//     ],
//     yAxis: [
//       {
//         axisLine: {
//           show: false
//         },
//         splitLine: {
//           show: false
//         }
//       }
//     ],

//     series: [
//       {
//         name: 'Leaves Rate',
//         type: 'pie',
//         radius: ['45%', '72.55%'],
//         center: ['50%', '50%'],
//         avoidLabelOverlap: false,
//         hoverOffset: 5,
//         stillShowZeroSum: false,
//         label: {
//           normal: {
//             show: false,
//             position: 'center', // shows the description data to center, turn off to show in right side
//             textStyle: {
//               color: theme.palette.text.secondary,
//               fontSize: 13,
//               fontFamily: 'roboto'
//             },
//             formatter: '{a}'
//           },
//           emphasis: {
//             show: true,
//             textStyle: {
//               fontSize: '14',
//               fontWeight: 'normal'
//               // color: "rgba(15, 21, 77, 1)"
//             },
//             formatter: '{b} \n{c} ({d}%)'
//           }
//         },
//         labelLine: {
//           normal: {
//             show: false
//           }
//         },
//         data: [
//           {
//             value: 65,
//             name: 'Planned'
//           },
//           {
//             value: 20,
//             name: 'Emergency'
//           },
//           { value: 15, name: 'Unpaid' }
//         ],
//         itemStyle: {
//           emphasis: {
//             shadowBlur: 10,
//             shadowOffsetX: 0,
//             shadowColor: 'rgba(0, 0, 0, 0.5)'
//           }
//         }
//       }
//     ]
//   };

//   return (
//     <ReactEcharts
//       style={{ height: height }}
//       option={{
//         ...option,
//         color: [...color]
//       }}
//     />
//   );
// };

// export default DoughnutChart;
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material';
import ReactEcharts from 'echarts-for-react';

const DoughnutChart = ({ height, color = [] }) => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  
  // Get the current month and year
  const currentMonth = new Date().getMonth(); // 0 to 11 (January = 0)
  const currentYear = new Date().getFullYear();
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(response => response.json())
      .then(data => {
        // Filter the data to include only APPROVED, PLANNED, and EMERGENCY for this month
        const filteredData = data
          .filter(row => 
            row.ApplicationStatus === 'APPROVED' && 
            (row.leavetype === 'PLANNED' || row.leavetype === 'EMERGENCY') &&
            new Date(row.startingdate).getMonth() === currentMonth &&
            new Date(row.startingdate).getFullYear() === currentYear
          );
        setData(filteredData);
      })
      .catch(error => console.error(error));
  }, []);

  // Calculate the counts for each leave type
  const plannedCount = data.filter(row => row.leavetype === 'PLANNED').length;
  const emergencyCount = data.filter(row => row.leavetype === 'EMERGENCY').length;
  
  // Calculate unpaid leaves as the remaining approved leaves for the current month
  const approvedLeavesCount = data.length;
  const unpaidCount = approvedLeavesCount - (plannedCount + emergencyCount);

  const option = {
    legend: {
      show: true,
      itemGap: 20,
      icon: 'circle',
      bottom: 0,
      textStyle: {
        color: '#000000', // Black legend text
        fontSize: 13,
        fontFamily: 'roboto'
      }
    },
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    series: [
      {
        name: 'Leaves Rate',
        type: 'pie',
        radius: ['45%', '72.55%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        hoverOffset: 5,
        stillShowZeroSum: true,
        label: {
          normal: {
            show: true,
            position: 'outside',
            textStyle: {
              color: '#000000', // Black text
              fontSize: 13,
              fontFamily: 'roboto'
            },
            formatter: '{b}: {c} ({d}%)'
          }
        },
        labelLine: {
          show: true,
          lineStyle: { color: '#000000' } // Black label lines
        },
        data: [
          {
            value: plannedCount,
            name: 'Planned',
            itemStyle: { color: '#3498db' } // Blue
          },
          {
            value: emergencyCount,
            name: 'Emergency',
            itemStyle: { color: '#e74c3c' } // Red
          },
          {
            value: unpaidCount,
            name: 'Unpaid',
            itemStyle: { color: '#f1c40f' } // Yellow
          }
        ],
        itemStyle: {
          emphasis: {
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0)' // Disable blur effect
          }
        }
      }
    ]
  };

  return (
    <ReactEcharts
      style={{ height: height }}
      option={{
        ...option,
        color: [...color]
      }}
    />
  );
};

export default DoughnutChart;